<section tuiContent>
	@if (context.data.message) {
		<p class="mt-0">{{ context.data.message | transloco }}</p>
	}

	@if (error(); as error) {
		<div tuiNotification class="mb-2" size="s" appearance="negative">
			{{ error | transloco }}
		</div>
	}

	@if (form) {
		<form
			[formGroup]="form"
			(ngSubmit)="onSubmit()"
			(keyup.enter)="onSubmit()"
		>
			<label tuiLabel>
				{{ 'data.email' | transloco }}

				<tui-textfield tuiTextfieldSize="m">
					<input
						formControlName="email"
						tuiInput
						autocomplete="email"
					/>
				</tui-textfield>

				<tui-error formControlName="email" [order]="['required']" />
			</label>

			<label tuiLabel>
				{{ 'data.password' | transloco }}

				<tui-textfield tuiTextfieldSize="m">
					<input
						tuiInput
						formControlName="password"
						type="password"
						autocomplete="current-password"
					/>
					<tui-icon tuiPassword />
				</tui-textfield>

				<tui-error formControlName="password" />
			</label>
		</form>
	}
</section>

<footer tuiFooter>
	<button tuiButton appearance="outline" (click)="onDismiss()">
		{{ 'action.cancel' | transloco }}
	</button>
	<button
		tuiButton
		type="submit"
		appearance="accent"
		(click)="onSubmit()"
		[disabled]="busy()"
		[loading]="busy()"
	>
		{{ 'auth.sign-in' | transloco }}
	</button>
</footer>
